import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type NowSlotExtended } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { nowBasicCheckRespGetSlotShippingIsToday } from '../../../../../now'
import { TENANT } from '../../../../../tenant'

export const ProductBuyBoxNowInfoDay: FC<{ nowSlot: NowSlotExtended }> = ({
  nowSlot,
}) => {
  const { tenant } = useGlobalConfigContext()
  const shippingIsToday = nowBasicCheckRespGetSlotShippingIsToday(nowSlot)
  const showShippingDayLabel = shippingIsToday ? (
    <FormattedMessage id="nowCountdown.shipTodayLabel" />
  ) : (
    <FormattedMessage id="nowCountdown.shopTomorrowLabel" />
  )

  return tenant === TENANT.COM ? (
    showShippingDayLabel
  ) : (
    <span className="mr-1 font-bold text-dark-brand">
      {showShippingDayLabel}
    </span>
  )
}
